import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import NewFormWizard from '../../../../components/formWizard/NewFormWizard'
import NewFormWizardChild from '../../../../components/formWizard/NewFormWziardChild'
import Layout from '../../../../components/layouts/Layout'
import UploadFile from '../../../../hook/UploadFile'
import { eventMicroSite } from '../slice/createEventSlice'
import MicrositeModal from '../../components/Modal/MicrositeModal'
import http, { URL_S3 } from '../../../../config/BaseUrl'
import { LoadingSpinner } from '../../../../components/Loader/Loader'
import HeaderTrackingModal from '../../components/Modal/HeaderTrackingModal'

const MicroSite = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const [microSite, setMicroSite] = useState(null)
    const [emailTemplateErr, setTemplateErr] = useState(false)
    const { event_option, micro_site, eventId } = useSelector(state => state.createEvent)
    const [loading, setLoading] = useState(false)
    const [draftLoading, setDraftLoading] = useState(false)
    const [my_social_gallery_id, setSocialMyTemplateId] = useState(null)
    const [socialTemplateType, setEmailTemplateType] = useState(null)
    const [socialTemplateContents, setEmailTemplateContents] = useState(null)
    const [openModal, setOpenModal] = useState(false)
    const [headerScript, setHeaderScript] = useState(null)
    const [socialGalleryOption, setSocialGalleryOption] = useState({
        // instagram: false,
        sms: false,
        email: false,
        // linked_in: false,
        // facebook: false,
        // twitter: false,
        download: false,
        // snapchat:false, 
        // tiktok:false, 
        // signal:false, 
        // telegram:false
    })
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: "all",
        reValidateMode: "onChange",
        defaultValues: {
            gallery_button: micro_site.gallery_button,
            meta_title: micro_site.meta_title,
            gallery_password: micro_site.gallery_password
        }

    })
    const { fileURL, onChangeFile, setFileURL } = UploadFile()

    useEffect(() => {
        if (micro_site) {
            setMicroSite(micro_site.microSite_template)
            setFileURL(micro_site.fileURL)
            setSocialGalleryOption({
                // instagram: micro_site.instagram,
                sms: micro_site.sms,
                email: micro_site.email,
                linked_in: micro_site.linked_in,
                // facebook: micro_site.facebook,
                // twitter: micro_site.twitter,
                download: micro_site.download,
                // snapchat:micro_site.snapchat, 
                // tiktok:micro_site.tiktok, 
                // signal:micro_site.signal, 
                // telegram:micro_site.telegram
            })
        }
    }, [micro_site])

    const handleHeaderScript = (data) => {
        setHeaderScript(data)
    }

    const handelMicroSite = async (data) => {
        if (microSite) {
            await dispatch(eventMicroSite({ ...data, ...socialGalleryOption, microSite_template: microSite, fileURL: fileURL, tag_script: headerScript }));
            setLoading(true)
            http.post("social-gallery", { ...data, ...socialGalleryOption, microsite_template: microSite, background_img: fileURL, eventId, template_type: socialTemplateType, my_social_gallery_id, contents: socialTemplateContents, tag_script: headerScript }).then(res => {
                setLoading(false)
                if (event_option.frame_option           === true) { history.push('/event/frame', eventId) }
                else if (event_option.incentive_offer   === true) { history.push('/event/incentive-offer', eventId) }
                else if (event_option.filters           === true) { history.push('/event/filter', eventId) }
                else if (event_option.form_builder === true) { history.push('/event/form-builder', eventId) }
                else { history.push('/event/summary', eventId) }
            }).catch(err => setLoading(false))

        }
        else {
            setTemplateErr(true)
        }
    }


    const setMicrositeByProps = (data) => {
        if ('contents' in data) {
            setMicroSite({id: data.id, image: data.image})
            setEmailTemplateContents(data.contents)
            setEmailTemplateType('my_template')
            setSocialMyTemplateId(data.my_social_gallery_id)
        }
        else{
            setMicroSite(data)
        }
        setMicroSite(data)
    }

    const selectAllSocialSharign = () => {
        let checkbox = document.querySelector(".select-all-item");
        if (checkbox.checked) {
            setSocialGalleryOption({
                // instagram: true,
                sms: true,
                email: true,
                // linked_in: true,
                // facebook: true,
                // twitter: true,
                download: true,
                // snapchat:true,
                // tiktok:true,
                // signal:true,
                // telegram:true,
            })
        }
        else {
            setSocialGalleryOption({
                // instagram: false,
                sms: false,
                email: false,
                // linked_in: false,
                // facebook: false,
                // twitter: false,
                download: false,
                // snapchat:false,
                // tiktok:false,
                // signal:false,
                // telegram:false,
            })
        }

    }

    const selectSocialGalleryItem = (e) => {
        let checkbox = document.querySelector(`input[name='${e.target.name}']`)

        if (checkbox.checked) {
            setSocialGalleryOption({ ...socialGalleryOption, [e.target.name]: true })
        }
        else {
            setSocialGalleryOption({ ...socialGalleryOption, [e.target.name]: false })
        }
    }

    const saveAsDraft = () => {
        handleSubmit(async (data) => {
            if (microSite) {
                await dispatch(eventMicroSite({ ...data, ...socialGalleryOption, microSite_template: microSite, fileURL: fileURL, tag_script: headerScript }));
                setDraftLoading(true)
                http.post("social-gallery", { ...data, ...socialGalleryOption, microsite_template: microSite, background_img: fileURL, eventId, tag_script: headerScript }).then(res => {
                    setDraftLoading(false)
                }).catch(err => setDraftLoading(false))

            }
            else {
                setTemplateErr(true)
            }
        })()
    }

    useEffect(()=>{
        if (typeof history.location.state == "object" && "editedData" in history.location.state) {
            const theData = history.location.state.editedData
            setMicroSite({id: theData.template.id, template_image:theData.template.image})
            setEmailTemplateType(theData.saveAs)
            setEmailTemplateContents(theData.content)
            if (theData.saveAs == 'my_template') {
                setSocialMyTemplateId(theData.my_social_gallery_id)
            }
            else{
                setSocialMyTemplateId(null)
            }
        }
    }, [history])

    const BackToPreviousPage = (e) => {
        e.preventDefault()
             if (event_option.water_mark     === true) { history.push('/event/custom-branding') }
        else if (event_option.digital_props  === true) { history.push('/event/digital-prop') }
        else if (event_option.text_messaging === true) { history.push('/event/sms') }
        else if (event_option.email          === true) { history.push('/event/email') }
        else if (event_option.brust_gif      === true) { history.push('/event/brust-gif') }
        else if (event_option.gif            === true) { history.push('/event/gif') }
        else if (event_option.social_media   === true) { history.push('/event/social') }
        else { history.push('/event/options') }
    }
    return (
        <Layout>
            <NewFormWizard />
            <NewFormWizardChild />
            <section className="mt-4">
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="text-center col-12 col-md-12">
                                        <div className="">
                                            <p className="mb-0 display-4 text-primary event-form-title">Social Gallery</p>
                                            <p className="mb-0 text-secondary">Edit gallery settings</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <form onSubmit={handleSubmit(handelMicroSite)} >
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="card">
                                <div className="card-body">
                                    <div className="py-4 bg-white border social__sharing__option__area radius-10">
                                        <div className="select-all d-flex align-items-center justify-content-between border-bottom">
                                            <h6 className="pl-2">Social Sharing Option</h6>
                                            <div className="icon__checkbox__area">
                                                <label htmlFor="SMS" className="">Select All</label>
                                                <input type="checkbox" className="form-control focus-none select-all-item" onChange={selectAllSocialSharign} />
                                                <span class="checkmark"></span>
                                            </div>
                                        </div>
                                        <div className="flex-wrap d-flex justify-content-center">
                                            <div className="icon__checkbox__area">
                                                <label htmlFor="SMS" className="">SMS</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.sms} name="sms" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>

                                            <div className="icon__checkbox__area">
                                                <label htmlFor="Email" className="">Email</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.email} name="email" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>

                                            {/* <div className="icon__checkbox__area">
                                                <label htmlFor="Facebook" className="">Facebook</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.facebook} name="facebook" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>

                                            <div className="icon__checkbox__area">
                                                <label htmlFor="Instagram" className="">Instagram</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.instagram} name="instagram" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>



                                            <div className="icon__checkbox__area">
                                                <label htmlFor="LinkedIn" className="">Linkedin</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.linked_in} name="linked_in" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>

                                            <div className="icon__checkbox__area">
                                                <label htmlFor="Twitter" className="">Twitter</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.twitter} name="twitter" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>

                                            <div className="icon__checkbox__area">
                                                <label htmlFor="snapchat" className="">Snapchat</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.snapchat} name="snapchat" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>
                                            <div className="icon__checkbox__area">
                                                <label htmlFor="tiktok" className="">TikTok</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.tiktok} name="tiktok" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>
                                            
                                            <div className="icon__checkbox__area">
                                                <label htmlFor="telegram" className="">Telegram</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.telegram} name="telegram" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div> */}

                                            {/* <div className="icon__checkbox__area">
                                                <label htmlFor="signal" className="">Signal</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.signal} name="signal" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div> */}

                                            <div className="icon__checkbox__area">
                                                <label htmlFor="Download" className="">Download</label>
                                                <input type="checkbox" onClick={selectSocialGalleryItem} checked={socialGalleryOption.download} name="download" className="form-control focus-none check-item" />
                                                <span class="checkmark"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card">
                                <div className="card-body">
                                    <h6 className="mb-4 text-center">Gallery Option</h6>
                                    <div className="p-3 bg-white form-group row ">
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <div class="input-group-text">
                                                    <input type="checkbox" aria-label="Checkbox for following text input" {...register("gallery_button")} />
                                                </div>
                                            </div>
                                            <input type="text" class="form-control" aria-label="Text input with checkbox" style={{ color: 'rgb(206,162,82)' }} disabled value="Hide Gallery From Social Gallery" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="py-3 card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-6 d-flex align-items-center flex-column justify-content-center">
                                                    <div className="place-holder-section">
                                                        {
                                                            !microSite ?
                                                                <div className="default-section">
                                                                    <h4>Choose Email Template.</h4>
                                                                </div>
                                                                :
                                                                <div className="default-section">
                                                                    <img src={`${URL_S3}image/micro_site/${microSite.template_image}`} className="img-fluid" alt="email-template" />
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="my-auto col-sm-6">
                                                    <button type="button" className="btn btn-primary btn-block" data-toggle="modal" data-target="#micro-site">Social Gallery Template Library</button>

                                                    <button type="button" className="btn btn-secondary btn-block" onClick={e=> setOpenModal(true)}>Header Tracking</button>

                                                    <p className={`pt-2 text-danger font-weight-bold fade ${emailTemplateErr ? 'show' : 'hide'}`}>Choose any template</p>
                                                    <MicrositeModal setData={setMicrositeByProps} />
                                                    <HeaderTrackingModal 
                                                        isOpen={openModal} 
                                                        closeModal={setOpenModal} 
                                                        handleHeaderScript={handleHeaderScript}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="card">
                                        <div className="card-body" style={{ minHeight: '350px' }}>
                                            {/* <div className="form-group">
                                                <label htmlFor="">Meta Title</label>
                                                <div className="input-group">
                                                    <input type="text" className="form-control" {...register("meta_title")} />
                                                </div>
                                            </div> */}
                                            <div className="form-group">
                                                <label htmlFor="">Gallery Password</label>
                                                <div className="input-group">
                                                    <input type="password" className="form-control" placeholder="Gallery Password" {...register("gallery_password")} />
                                                </div>
                                                <small>Leave blank if you don't want the gallery password protected</small>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="my-5 row">
                                <div className="col-md-12">
                                    <button type="button" onClick={BackToPreviousPage} className="float-left px-5 btn btn-outline-secondary radius-10">Back</button>
                                    {loading ?
                                        (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                                            <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                        </button>)
                                        : <button type="submit" disabled={draftLoading} className="float-right px-5 btn btn-primary radius-10">Next</button>
                                    }
                                    {
                                        loading ?
                                            (<button className="float-right px-3 mr-2 btn btn-secondary radius-10" disabled>
                                                <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                            </button>)
                                            :
                                            <button type="button" onClick={saveAsDraft} className="float-right px-3 mr-2 btn btn-secondary radius-10">Save as draft</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </Layout>
    )
}

export default MicroSite
